import React from 'react';
import SettingsMenu from './SettingsMenu';

/**
 * SettingsManager Component
 * 
 * Manages the settings modal overlay and integrates with user preferences.
 * Extracted from ChatApp component to provide a focused settings management interface.
 */
const SettingsManager = ({
  visible,
  onClose,
  preferences,
  onUpdatePreferences,
  onSignOut,
  onOpenAdmin,
  loading = false,
  signOutLoading = false,
  isAdmin = false,
}) => {
  if (!visible) {
    return null;
  }

  // Handle null/undefined preferences gracefully
  if (!preferences) {
    console.warn('SettingsManager: preferences prop is null or undefined');
    return null;
  }

  // Handle saving preferences
  const handleSave = async () => {
    try {
      await onUpdatePreferences();
      onClose();
    } catch (error) {
      // Error handling is done in the onUpdatePreferences function
      console.error('Failed to save preferences:', error);
    }
  };

  return (
    <div className="settings-overlay">
      <SettingsMenu
        audioMode={preferences.audioMode}
        setAudioMode={preferences.setAudioMode}
        showLeaderBoard={preferences.showLeaderBoard}
        setShowLeaderBoard={preferences.setShowLeaderBoard}
        showIntro={preferences.showIntroPreference}
        setShowIntro={preferences.setShowIntroPreference}
        onClose={onClose}
        onSave={handleSave}
        onSignOut={onSignOut}
        onOpenAdmin={onOpenAdmin}
        loading={loading}
        signOutLoading={signOutLoading}
        isAdmin={isAdmin}
      />
    </div>
  );
};

export default SettingsManager;
